
import {
  RESET_MESSAGES
} from "../reducers/type";

export const resetMessage = () => async (dispatch) => {
    dispatch({ type: RESET_MESSAGES});
      
}
